import { promotionDefaultCols } from 'Src/const/state/statistics-fields-promotion.js'
// import json from 'Src/util/json'
// import * as CampaignState from 'Src/const/state/campaign'

// export const localStorageColsKey = 'promotionCustomizedCols'
export const localStorageColsKey = 'promotionCustomizedCols-pro'

let localColsConf = window.localStorage.getItem(localStorageColsKey)
// 判断是否为搜索广告
// const isSearchAd = json.catchableParse(GLOBAL_VAR.campaignType) === CampaignState.campaignType.SEARCH_AD.value

function getCustomizedColsLocalStorage () {
  if (localColsConf && localColsConf !== '') {
    let currentLocalColsConf = JSON.parse(localColsConf)
    // 关键词质量度是搜索广告新加的白名单指标，如果用户使用过自定义排序，会读缓存中的列表信息，为了上线后，能让用户看到的这个指标的位置靠前做的兼容处理
    if (!window.localStorage.getItem('promotion_keyword_quality_initialize') && !currentLocalColsConf.some(item => item.id === 'quality')) {
      currentLocalColsConf.splice(2, 0, {
        columnConfigurable: true,
        id: 'quality',
        text: $bp_t('关键词质量度', 'promotion_keyword_quality')
      })
      // 用 promotion_keyword_quality_initialize 来标识是否给用户直接操作过
      window.localStorage.setItem('promotion_keyword_quality_initialize', 'true')
      window.localStorage.setItem(localStorageColsKey, JSON.stringify(currentLocalColsConf))
    }
    localColsConf = currentLocalColsConf
  } else {
    localColsConf = undefined
  }
}

getCustomizedColsLocalStorage()

function setCustomizedColsLocalStorage (cols) {
  window.localStorage.setItem(localStorageColsKey, JSON.stringify(cols))
}

export const PAGINATION_CHANGE = 'paginationChange'
export const PAGE_CHANGE = 'pageChange'
export const PAGE_SIZE_CHANGE = 'pageSizeChange'
export const TOTAL_NUMBER_CHANGE = 'totalNumberChange'
export const TOTAL_PAGE_CHANGE = 'totalPageChange'
export const CUSTOMIZED_COLS_CHANGE = 'customizedColsChange'
export const GLOBAL_FILTERS_PARAMS_CHANGE = 'globalFiltersParamsChange'
export const GLOBAL_FILTERS_PARAMS_REPLACE = 'globalFiltersParamsReplace'
export const DATE_FILTER_CHANGE = 'dateFilterChange'
export const DRAWER_INIT_INFO_CHANGE = 'drawerInitInfoChange'
export const IS_SHOW_RIGHT_DRAWER_CHANGE = 'isShowRightDrawerChange'
export const ADD_GLOBAL_TYPE_SEARCH = 'addGlobalTypeSearch'
export const SPLICE_GLOBAL_TYPE_SEARCH = 'spliceGlobalTypeSearch'
export const FILTERS_CHANGE = 'FILTERS_CHANGE'
export const SET_SELECTED_ROW_INDEX = 'SET_SELECTED_ROW_INDEX'
export const SHOW_AUDIT_DRAWER = 'SHOW_AUDIT_DRAWER'
export const AUTO_MATE_RULES_PARAM = 'metrics_range_filter'
export const FILTERS_SET = 'FILTERS_SET'
export const DefaultParams = {
  sort_stat: 'create_time',
  sort_order: 1,
  [AUTO_MATE_RULES_PARAM]: []
}

// eslint-disable-next-line
export default new Vuex.Store({
  state: {
    customizedCols: localColsConf || promotionDefaultCols,
    // JSON String，因该对象属性不确定，不便于监听属性变化，故采用字符串形式。
    // 默认按时间降序排序
    globalFiltersParams: JSON.stringify(DefaultParams),
    pagination: {
      pageSize: 10,
      totalNum: 0,
      curPage: 1,
      totalPage: 1
    },
    dateFilter: {
      start: '',
      end: ''
    },
    typeSearchBoxes: [
      // {
      //   typeVal: 2, // 类型标记值，即后端接口search_type（ https://yapi.bytedance.net/project/1136/interface/api/1021123 ）
      //   typeName: '计划', // 类型中文名称
      //   searchTerm: '名称' // 搜索关键词
      // }
    ],
    isShowRightDrawer: false,
    drawerInitInfo: {
      nav: '',
      secondNav: '',
      level: '',
      campaignIds: [],
      adIds: [],
      creativeIds: [],
      st: '',
      et: '',
      isCampaignBudgetOptimize: 0
    },
    startInitTriggerGuide: false,
    URLFilters: [],
    selectedRowIndex: undefined,
    auditDrawerData: {
      landingType: '',
      purchaseType: '',
      campaignID: '',
      adID: '',
      creativeID: '',
      wordId: ''
    },
    requestId: ''
  },
  mutations: {
    [PAGE_CHANGE] (state, payload) {
      const newVal = parseInt(payload)
      if (newVal !== state.pagination.curPage) {
        state.pagination.curPage = newVal
      }
    },
    [PAGE_SIZE_CHANGE] (state, payload) {
      const newVal = parseInt(payload)
      if (newVal !== state.pagination.pageSize) {
        state.pagination.pageSize = newVal
      }
    },
    [TOTAL_NUMBER_CHANGE] (state, payload) {
      const newVal = parseInt(payload)
      if (newVal !== state.pagination.totalNum) {
        state.pagination.totalNum = newVal
      }
    },
    [TOTAL_PAGE_CHANGE] (state, payload) {
      const newVal = parseInt(payload)
      if (newVal !== state.pagination.totalPage) {
        state.pagination.totalPage = newVal
      }
    },
    [CUSTOMIZED_COLS_CHANGE] (state, payload) {
      state.customizedCols = payload

      setCustomizedColsLocalStorage(payload)
    },
    [GLOBAL_FILTERS_PARAMS_CHANGE] (state, payload) {
      let tempGlobalFiltersParams = JSON.parse(state.globalFiltersParams)
      if (Object.keys(payload).length >= 1) {
        Object.assign(tempGlobalFiltersParams, payload)
      } else {
        tempGlobalFiltersParams = {}
      }
      state.globalFiltersParams = JSON.stringify(tempGlobalFiltersParams)
    },
    [GLOBAL_FILTERS_PARAMS_REPLACE] (state, payload) {
      state.globalFiltersParams = JSON.parse(state.globalFiltersParams)
      state.globalFiltersParams = payload
      state.globalFiltersParams = JSON.stringify(state.globalFiltersParams)
    },
    [DATE_FILTER_CHANGE] (state, payload) {
      state.dateFilter = {
        start: payload.start,
        end: payload.end
      }
    },
    [ADD_GLOBAL_TYPE_SEARCH] (state, payload) {
      state.typeSearchBoxes = payload
    },
    [SPLICE_GLOBAL_TYPE_SEARCH] (state, indexPayload) {
      state.typeSearchBoxes.splice(indexPayload, 1)
    },
    [DRAWER_INIT_INFO_CHANGE] (state, payload) {
      state.drawerInitInfo = JSON.parse(JSON.stringify(payload))
      // 侧弹数据初始化埋点
      window.teaEvent('promotion_drawer_init', {
        promotion_level: state.drawerInitInfo.level,
        promotion_drawer_nav: state.drawerInitInfo.nav,
        promotion_drawer_second_nav: state.drawerInitInfo.secondNav
      })
    },
    [IS_SHOW_RIGHT_DRAWER_CHANGE] (state, payload) {
      state.isShowRightDrawer = payload
    },
    [FILTERS_CHANGE] (state, payload) {
      state.URLFilters.push(payload)
    },
    [FILTERS_SET] (state, payload) {
      state.URLFilters = payload
    },
    [SET_SELECTED_ROW_INDEX] (state, payload) {
      state.selectedRowIndex = payload
    },
    [SHOW_AUDIT_DRAWER] (state, payload) {
      state.auditDrawerData = payload
    }
  },
  actions: {
    [PAGINATION_CHANGE] (context, payload) {
      context.commit(PAGE_CHANGE, payload.page)
      context.commit(PAGE_SIZE_CHANGE, payload.page_size)
      context.commit(TOTAL_NUMBER_CHANGE, payload.total_count)
      context.commit(TOTAL_PAGE_CHANGE, payload.total_page)
    }
  }
})
